<template>
    <span>
        <a :href="link" :target="targetBlank" v-if="type === 'external' || !router" :class="classes">
            <slot></slot>
        </a>

        <router-link :to="relativeLink" :target="targetBlank" v-else>
            <slot></slot>
        </router-link>
    </span>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: false,
        },
        link: {
            type: String,
            required: true,
        },
        classes: {
            type: String,
            required: false,
        },
        router: {
            type: Boolean,
            required: false,
            default: true,
        },
        target: {
            type: String,
            required: false,
        },
    },
    computed: {
        relativeLink: function () {
            let url = this.link

            try {
                url = new URL(url)
                return url.pathname
            } catch (error) {
                return url
            }
        },
        targetBlank: function () {
            return this.target ? 'target_blank' : ''
        },
    },
}
</script>
